import React from 'react';

const SRGLetterboxPlayerControls = ({ letterboxInstance }) => {
  return (
    <>
      <h1 className="content__title">Controls</h1>
      <div className="controls">
        <button className="controls__button" onClick={() => letterboxInstance.play()}>Play</button>
        <button className="controls__button" onClick={() => letterboxInstance.pause()}>Pause</button>
        <button className="controls__button"onClick={() => letterboxInstance.restart(false)}>Stop</button>
        <button
          className="controls__button"
          onClick={() => letterboxInstance.player.volume(letterboxInstance.player.volume() + 0.1)}
        >
          Volume Up
        </button>
        <button
          className="controls__button"
          onClick={() => letterboxInstance.player.volume(letterboxInstance.player.volume() - 0.1)}
        >
          Volume Down
        </button>
        <button
          className="controls__button"
          onClick={() =>
            letterboxInstance.player.volume(letterboxInstance.player.volume() > 0 ? 0 : 1)
          }
        >
          Mute / Unmute
        </button>
      </div>
    </>
  );
};

export default SRGLetterboxPlayerControls;
